/* tslint:disable */
/* eslint-disable */
/**
 * Litiverse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PartyRoleEnum } from './PartyRoleEnum';
import {
    PartyRoleEnumFromJSON,
    PartyRoleEnumFromJSONTyped,
    PartyRoleEnumToJSON,
    PartyRoleEnumToJSONTyped,
} from './PartyRoleEnum';
import type { PartyTypeEnum } from './PartyTypeEnum';
import {
    PartyTypeEnumFromJSON,
    PartyTypeEnumFromJSONTyped,
    PartyTypeEnumToJSON,
    PartyTypeEnumToJSONTyped,
} from './PartyTypeEnum';

/**
 * 
 * @export
 * @interface Party
 */
export interface Party {
    /**
     * 
     * @type {number}
     * @memberof Party
     */
    id?: number | null;
    /**
     * Full name of the party
     * @type {string}
     * @memberof Party
     */
    name: string;
    /**
     * 
     * @type {PartyRoleEnum}
     * @memberof Party
     */
    role?: PartyRoleEnum | null;
    /**
     * 
     * @type {PartyTypeEnum}
     * @memberof Party
     */
    type?: PartyTypeEnum | null;
    /**
     * 
     * @type {Date}
     * @memberof Party
     */
    createdAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof Party
     */
    updatedAt?: Date | null;
}



/**
 * Check if a given object implements the Party interface.
 */
export function instanceOfParty(value: object): value is Party {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function PartyFromJSON(json: any): Party {
    return PartyFromJSONTyped(json, false);
}

export function PartyFromJSONTyped(json: any, ignoreDiscriminator: boolean): Party {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'],
        'role': json['role'] == null ? undefined : PartyRoleEnumFromJSON(json['role']),
        'type': json['type'] == null ? undefined : PartyTypeEnumFromJSON(json['type']),
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'updatedAt': json['updated_at'] == null ? undefined : (new Date(json['updated_at'])),
    };
}

export function PartyToJSON(json: any): Party {
    return PartyToJSONTyped(json, false);
}

export function PartyToJSONTyped(value?: Party | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'role': PartyRoleEnumToJSON(value['role']),
        'type': PartyTypeEnumToJSON(value['type']),
        'created_at': value['createdAt'] == null ? undefined : ((value['createdAt'] as any).toISOString()),
        'updated_at': value['updatedAt'] == null ? undefined : ((value['updatedAt'] as any).toISOString()),
    };
}

